export default "/images/portrait-bg.jpg?398c4a6285ea900ad52f6cd96a45453e";